import React, { Component } from 'react'

import Swiper from 'swiper'
// import { Carousel } from 'antd';

import ColumnTitle from '../ColumnTitle'

import jbtit from '../../assets/img/jbtit.png'

import { ForumGuestsWrapper } from './style'

import gpy from './../../assets/img/gpy.jpg'
import lsj from './../../assets/img/lsj.jpg'
import pg from './../../assets/img/pg.jpg'
import hkb from './../../assets/img/hkb.jpg'
import txl from './../../assets/img/txl.jpg'
import lyc from './../../assets/img/lyc.jpg'
import zyn from './../../assets/img/zyn.jpg'
import bce from './../../assets/img/bce.jpg'
import xl from './../../assets/img/xl.jpg'
import lge from './../../assets/img/lge.jpg'
import zyl from './../../assets/img/zyl.jpg'
import xxc from './../../assets/img/xxc.jpg'
import lsx from './../../assets/img/lsx.jpg'
import zg from './../../assets/img/zg.jpg'
import zj from './../../assets/img/zj.jpg'
import hqh from './../../assets/img/hqh.jpg'
import ltj from './../../assets/img/ltj.jpg'
import zgd from './../../assets/img/zgd.jpg'
import csf from './../../assets/img/csf.jpg'
import zkz from './../../assets/img/zkz.jpg'
import xcl from './../../assets/img/xcl.jpg'
import th from './../../assets/img/th.png'



export default class ForumGuests extends Component {
    state = {
        guests: [
            {
                key: 'arr_01',
                data: [
                    {
                        id: 'jb_001',
                        imgSrc: gpy
                    },
                    {
                        id: 'jb_002',
                        imgSrc: lsj
                    },
                    {
                        id: 'jb_003',
                        imgSrc: pg
                    },
                    {
                        id: 'jb_004',
                        imgSrc: hkb
                    },
                    {
                        id: 'jb_005',
                        imgSrc: txl
                    },
                    {
                        id: 'jb_006',
                        imgSrc: lyc
                    },
                    {
                        id: 'jb_007',
                        imgSrc: zyn
                    },
                    {
                        id: 'jb_008',
                        imgSrc: bce
                    },
                    {
                        id: 'jb_009',
                        imgSrc: xl
                    },
                    {
                        id: 'jb_010',
                        imgSrc: lge
                    },
                ]
            },
            {
                key: 'arr_02',
                data: [
                    {
                        id: 'jb_011',
                        imgSrc: zyl
                    },
                    {
                        id: 'jb_012',
                        imgSrc: xxc
                    },
                    {
                        id: 'jb_013',
                        imgSrc: lsx
                    },
                    {
                        id: 'jb_014',
                        imgSrc: zg
                    },
                    {
                        id: 'jb_015',
                        imgSrc: zj
                    },
                    {
                        id: 'jb_016',
                        imgSrc: hqh
                    },
                    {
                        id: 'jb_017',
                        imgSrc: ltj
                    },
                    {
                        id: 'jb_018',
                        imgSrc: zgd
                    },
                    {
                        id: 'jb_019',
                        imgSrc: csf
                    },
                    {
                        id: 'jb_20',
                        imgSrc: zkz
                    },
                ]
            },
            {
                key: 'arr_03',
                data: [
                    {
                        id: 'jb_21',
                        imgSrc: xcl
                    }
                ]
            }


        ]
    }
    handleClickLeft = () => {
        const { mySwiper } = this;
        mySwiper.slidePrev()
    }
    handleClickRight = () => {
        const { mySwiper } = this;
        mySwiper.slideNext()
    }
    componentDidMount() {
        this.mySwiper = new Swiper(".mySwiper", {
            loop: true,
            slidesPerView: 5,
            spaceBetween: 10
        })
    }
    render() {
        return (
            <ForumGuestsWrapper>
                <ColumnTitle imgSrc={jbtit} />
                <div className='carousel'>
                    <span className="ll" onClick={this.handleClickLeft}></span>
                    <span className="rr" onClick={this.handleClickRight}></span>
                    <div className="swiper mySwiper">
                        <div className="swiper-wrapper">
                            <div className="swiper-slide">
                                <img src={gpy} alt="" />
                                <img src={lsj} alt="" />
                            </div>
                            <div className="swiper-slide">
                                <img src={pg} alt="" />
                                <img src={hkb} alt="" />
                            </div>
                            <div className="swiper-slide">
                                <img src={txl} alt="" />
                                <img src={lyc} alt="" />
                            </div>
                            <div className="swiper-slide">
                                <img src={zyn} alt="" />
                                <img src={bce} alt="" />
                            </div>
                            <div className="swiper-slide">
                                <img src={xl} alt="" />
                                <img src={lge} alt="" />
                            </div>
                            <div className="swiper-slide">
                                <img src={zyl} alt="" />
                                <img src={xxc} alt="" />
                            </div>
                            <div className="swiper-slide">
                                <img src={lsx} alt="" />
                                <img src={zg} alt="" />
                            </div>
                            <div className="swiper-slide">
                                <img src={zj} alt="" />
                                <img src={hqh} alt="" />
                            </div>
                            <div className="swiper-slide">
                                <img src={ltj} alt="" />
                                <img src={zgd} alt="" />
                            </div>
                            <div className="swiper-slide">
                                <img src={csf} alt="" />
                                <img src={zkz} alt="" />
                            </div>
                            <div className="swiper-slide">
                                <img src={xcl} alt="" />
                                <img src={th} alt="" />
                            </div>
                        </div>

                    </div>
                    {/* <div className="swiper-button-next"></div> */}
                    {/* <div className="swiper-button-prev"></div> */}
                </div>
            </ForumGuestsWrapper>
        )
    }
}
